<template>
  <nav class="navbar py-1 navbar-expand navbar-light bg-white">
    <div :class="containerClass">
      <router-link :to="{ name: getHomePage() }" class="navbar-brand p-0">
        <img src="/svg/logo1_citrus_final.svg" :alt="appName" style="width:100px">
      </router-link>
      <ul class="navbar-nav">
          <li class="nav-item" v-if="isParticipant&&$route.name!='home'">
            <router-link :to="{ name: getHomePage() }" class="nav-link">
              <fa icon="home" fixed-width />
            </router-link>
          </li>
          <li class="nav-item" v-if="isParticipant">
            <router-link :to="{ name: 'journey' }" class="nav-link">
              <fa icon="info-circle" fixed-width />
            </router-link>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <notifications-icon v-if="isAdmin||isParticipant" auth-user class="nav-item mt-1 mr-1" />
          <li v-if="user" class="nav-item dropdown">
            <a ref="settings_dropdown" class="nav-link px-2 dropdown-toggle text-dark"
               href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img :src="user.photo_url" class="rounded-circle profile-photo mr-1">
              {{ user.name }}
            </a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'settings.profile' }" class="dropdown-item pl-3">
                <fa icon="cog" fixed-width/>
                {{ $t('settings') }}
              </router-link>
              <router-link v-if="isAdmin" :to="{ name: 'tablelist' }" class="dropdown-item pl-3">
                <fa icon="user-shield" fixed-width/>
                {{ $t('admin') }}
              </router-link>
              <div class="dropdown-divider"/>
              <a v-if="isAdmin" href="/api/admin/export_data" class="dropdown-item pl-3">
                <fa icon="file-export" fixed-width/>
                {{ $t('data_export') }}
              </a>
              <a v-if="isAdmin" href="/api/admin/export_analysis" class="dropdown-item pl-3">
                <fa icon="file-export" fixed-width/>
                {{ $t('analysis_export') }}
              </a>
              <a v-if="isAdmin" href="/api/admin/export_aspa" class="dropdown-item pl-3">
                <fa icon="file-export" fixed-width/>
                {{ $t('aspa_export') }}
              </a>
              <a v-if="isAdmin" href="/api/admin/export_bowel" class="dropdown-item pl-3">
                <fa icon="file-export" fixed-width/>
                {{ $t('bowel_export') }}
              </a>
              <a v-if="isAdmin" href="/api/admin/export_sleep" class="dropdown-item pl-3">
                <fa icon="file-export" fixed-width/>
                {{ $t('sleep_export') }}
              </a>
              <a v-if="isAdmin" href="/api/admin/export_system" class="dropdown-item pl-3">
                <fa icon="file-export" fixed-width/>
                {{ $t('system_export') }}
              </a>
              <div class="dropdown-divider"/>
              <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                <fa icon="sign-out-alt" fixed-width/>
                {{ $t('logout') }}
              </a>
            </div>
          </li>
          <!-- Guest -->
          <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="btn btn-outline-primary" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
          </template>
        </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {

  data: () => ({
    appName: window.config.appName
  }),

  computed: {
    ...mapGetters('auth',['user','isAdmin','isParticipant']),
    containerClass () {
      var mq = this.$mq
      var classArr = []
      if(mq == 'xl') classArr.push('container')
        else  classArr.push('container-fluid')
      if(mq == 'xl') classArr.push('px-1')
      return classArr
    }
  },
  mounted () {
    $(this.$refs.settings_dropdown).dropdown()
  },
  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },
    getHomePage () {
      if(!this.user) return 'welcome'
      var roleNames = _.map(this.user.roles, (r) => r.name)
      if(_.includes(roleNames,'Participant')) return 'home'
      return 'dashboard'
    }
  },
  async onIdle() {
    if (this.user) {
    swal({
          type: 'warning',
          title: this.$i18n.t('token_expired_alert_title'),
          text: this.$i18n.t('token_expired_alert_text'),
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('ok'),
          cancelButtonText: this.$i18n.t('cancel')
        }).then(async () => {
          await this.$store.dispatch('auth/logout')
          this.$router.push({ name: 'login' })
        })
    }
  },
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
.dropdown.show {
    width: 100px;
}
.dropdown-menu.show{
  position:absolute;
}
</style>
